import { useState, useEffect } from "react";
import { startDate, endDate } from '../../../elements/DateRangePicker';

export const useFilterCards = (open, data) => {
    const [isValid, setIsValid] = useState(true)
    const [form, setForm] = useState({});
    const [error, setErrors] = useState("")
    const [loader, setLoader] = useState(true);

    const onHandleChange = (key1, key2, key3, e) => {
        let f = form;
        let er = error;
        let value = e.target.value;

        if(key2){
            f['filters'][key1][key2] = value;
        } else if(key3){
            let index = f['filters'][key1].indexOf(key3)
            if(index > -1){
                f['filters'][key1].splice(index, 1);
            } else {
                f['filters'][key1].push(key3);
            }
        }

        if (!value) {
            er = "Dato obligatorio";
        } else {
            er = "";
        }
        setForm(JSON.parse(JSON.stringify(f)));
        setErrors(JSON.parse(JSON.stringify(er)));
        validate(f, er);
    };

    const validate = (f, er) => {
        f['filters'].status && !er ? setIsValid(false) : setIsValid(true);
    };

    useEffect(() => {
                if (open) {
            setForm({
                filters: {
                    type: ["worker"],
                    status: data.filters.status,
                    dates: {
                        start: startDate,
                        end: endDate
                    },
                },
                pagination: {
                    page_number: 1,
                    results_per_page: 30
                }
            })
            setLoader(false)
        } else {
            setLoader(true)
            setIsValid(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return { onHandleChange, form, error, isValid, loader };
};
